import { render } from "./UserDetailsView.vue?vue&type=template&id=46a109f2"
import script from "./UserDetailsView.vue?vue&type=script&lang=js"
export * from "./UserDetailsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/UserDetailsView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46a109f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46a109f2', __exports__)) {
    api.reload('46a109f2', __exports__)
  }
  
  module.hot.accept("./UserDetailsView.vue?vue&type=template&id=46a109f2", () => {
    api.rerender('46a109f2', render)
  })

}


export default __exports__